import SwaggerCollection from './SwaggerCollection';

class ApiTesterStore {
  swaggers = new SwaggerCollection();
}

export default new ApiTesterStore();
